module.exports = __webpack_public_path__ + "img/banner1.92c9c711.png";